import { useState } from 'react';

import Button from '../button/Button';

function About2() {

    const [dataBlock] = useState({
        subheading: 'About me',
        heading: 'Senior Full-Stack Engineer & Designer',
        desc1: "I'm Jacob Rajan — a Chennai-based Senior Full-Stack Engineer with 7+ years of experience crafting enterprise web applications. I've led development across security platforms, SaaS dashboards, and data-heavy interfaces at companies like DataSirpi and Wolphix.",
        desc2: 'My stack centers on React, Next.js, Node.js, and TypeScript — with a strong eye for UI/UX and system design. I bridge the gap between engineering and design, building products that are both technically robust and visually refined.',
    });

    const cardBase = {
        borderRadius: 26,
        border: '1px solid rgba(255,255,255,0.08)',
        background: 'linear-gradient(135deg, rgba(13,13,30,0.95) 0%, rgba(20,15,45,0.92) 100%)',
        backdropFilter: 'blur(8px)',
        position: 'relative',
        overflow: 'hidden',
        transition: 'transform 0.35s cubic-bezier(.22,.68,0,1.2), border-color 0.35s ease, box-shadow 0.35s ease',
    };

    const labelBase = {
        position: 'absolute',
        bottom: 20,
        left: 20,
        right: 20,
        background: 'rgba(0,0,0,0.35)',
        backdropFilter: 'blur(8px)',
        borderRadius: 11,
        padding: '12px 16px',
        border: '1px solid rgba(255,255,255,0.06)',
    };

    return (
        <section className="about s2">
            <style>{`
                .bento-grid {
                    display: grid;
                    grid-template-columns: 1.35fr 1fr 1fr;
                    grid-template-rows: 240px 240px;
                    gap: 16px;
                    margin: 0 auto 48px;
                    max-width: 900px;
                }
                .bc:hover {
                    transform: translateY(-6px);
                    border-color: rgba(92,39,254,0.45) !important;
                }
                .bc .lbl h5 {
                    font-size: 14px;
                    font-weight: 700;
                    color: #fff;
                    margin: 0 0 3px;
                    line-height: 1.3;
                }
                .bc .lbl p {
                    font-size: 11px;
                    color: rgba(222,199,255,0.6);
                    margin: 0;
                    font-weight: 300;
                }
                .bc .lbl-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-end;
                }
                .grad-dot {
                    width: 26px; height: 26px;
                    border-radius: 50%;
                    background: linear-gradient(264.28deg, #DEC7FF -38.2%, #5C27FE 103.12%);
                    display: flex; align-items: center; justify-content: center;
                    flex-shrink: 0;
                }
                @media (max-width: 767px) {
                    .bento-grid {
                        grid-template-columns: 1fr;
                        grid-template-rows: auto;
                        max-width: 100%;
                    }
                    .bc-wide { grid-column: span 1 !important; }
                    .bc-tall { grid-row: span 1 !important; height: auto; min-height: 280px; }
                    .bc { height: auto; min-height: 260px; }
                    .bio-grid {
                        grid-template-columns: 1fr !important;
                        gap: 32px !important;
                    }
                    .bio-grid > div:first-child {
                        text-align: center;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                    }
                    .bring-grid {
                        display: grid !important;
                        grid-template-columns: 1fr 1fr !important;
                        gap: 16px !important;
                    }
                    .bring-item {
                        flex-direction: column !important;
                        align-items: flex-start !important;
                        gap: 10px !important;
                        background: linear-gradient(135deg, rgba(13,13,30,0.95) 0%, rgba(20,15,45,0.92) 100%);
                        border: 1px solid rgba(255,255,255,0.08);
                        border-radius: 16px;
                        padding: 16px !important;
                    }
                }
            `}</style>

            <div className="shape"></div>
            <div className="shape right"></div>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="block-text center pd-0">
                            <h6 className="sub-heading"><span>{dataBlock.subheading}</span></h6>
                            <h3 className="heading pd">{dataBlock.heading}</h3>
                        </div>

                        <div className="about__main center" data-aos="fade-up" data-aos-duration="3000">

                            <div className="bento-grid">

                                {/* Card 1 — Wide: Full-Stack Engineering */}
                                <div className="bc bc-wide" style={{ ...cardBase, gridColumn: 'span 2', padding: '28px 28px 90px' }}>
                                    <div style={{ textAlign: 'left', fontFamily: '"Fira Code","Menlo",monospace', fontSize: 13, lineHeight: 2 }}>
                                        <span style={{ color: 'rgba(222,199,255,0.85)' }}>const </span>
                                        <span style={{ color: 'rgba(255,255,255,0.7)' }}>stack </span>
                                        <span style={{ color: 'rgba(255,255,255,0.3)' }}>= {'{'}</span>
                                        <br />
                                        <span style={{ color: 'rgba(255,255,255,0.3)', paddingLeft: 20 }}>frontend</span>
                                        <span style={{ color: 'rgba(255,255,255,0.25)' }}>: </span>
                                        <span style={{ color: '#a78bfa' }}>'React · Next.js · TypeScript'</span>
                                        <span style={{ color: 'rgba(255,255,255,0.25)' }}>,</span>
                                        <br />
                                        <span style={{ color: 'rgba(255,255,255,0.3)', paddingLeft: 20 }}>backend</span>
                                        <span style={{ color: 'rgba(255,255,255,0.25)' }}>: </span>
                                        <span style={{ color: '#a78bfa' }}>'Node.js · Express · GraphQL'</span>
                                        <span style={{ color: 'rgba(255,255,255,0.25)' }}>,</span>
                                        <br />
                                        <span style={{ color: 'rgba(255,255,255,0.3)', paddingLeft: 20 }}>db</span>
                                        <span style={{ color: 'rgba(255,255,255,0.25)' }}>: </span>
                                        <span style={{ color: '#a78bfa' }}>'PostgreSQL · MongoDB · Redis'</span>
                                        <span style={{ color: 'rgba(255,255,255,0.25)' }}>,</span>
                                        <br />
                                        <span style={{ color: 'rgba(255,255,255,0.3)' }}>{'}'}</span>
                                    </div>
                                    {/* glowing pulse dot */}
                                    <div style={{ position: 'absolute', top: 22, right: 24, width: 9, height: 9, borderRadius: '50%', background: '#5c27fe', boxShadow: '0 0 0 4px rgba(92,39,254,0.25), 0 0 16px 4px rgba(92,39,254,0.4)' }} />
                                    <div className="lbl" style={labelBase}>
                                        <h5>Full-Stack Engineering</h5>
                                        <p>React · Next.js · Node.js · TypeScript</p>
                                    </div>
                                </div>

                                {/* Card 2 — Tall: UI & Design */}
                                <div className="bc bc-tall" style={{ ...cardBase, gridRow: 'span 2', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 10, padding: '28px 28px 100px' }}>
                                    {[
                                        { w: '88%', h: 7, o: 0.5 },
                                        { w: '68%', h: 7, o: 0.32 },
                                        { w: '100%', h: 32, o: 0.1, r: 10 },
                                        { w: '58%', h: 7, o: 0.25 },
                                        { w: '80%', h: 7, o: 0.18 },
                                        { w: '50%', h: 7, o: 0.15 },
                                        { w: '60%', h: 30, o: 0.3, r: 8 },
                                    ].map((s, i) => (
                                        <div key={i} style={{
                                            width: s.w, height: s.h,
                                            borderRadius: s.r ?? 20,
                                            background: `linear-gradient(90deg, rgba(92,39,254,${s.o}) 0%, rgba(222,199,255,${s.o * 0.45}) 100%)`,
                                            flexShrink: 0,
                                        }} />
                                    ))}
                                    <div className="lbl" style={{ ...labelBase, bottom: 20 }}>
                                        <div className="lbl-row">
                                            <div>
                                                <h5>UI & Design Systems</h5>
                                                <p>Figma · SCSS · Tailwind</p>
                                            </div>
                                            <div className="grad-dot">
                                                <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M2 10L10 2M10 2H4M10 2v6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Card 3 — Backend & APIs */}
                                <div className="bc" style={{ ...cardBase, padding: '24px 24px 90px', display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 12 }}>
                                    {[
                                        { method: 'GET', path: '/api/users', color: '#4ade80' },
                                        { method: 'POST', path: '/api/auth', color: '#60a5fa' },
                                        { method: 'PUT', path: '/api/data', color: '#fbbf24' },
                                    ].map((r) => (
                                        <div key={r.method} style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                                            <span style={{ fontSize: 10, fontWeight: 700, color: r.color, fontFamily: '"Fira Code",monospace', minWidth: 38, letterSpacing: 0.5 }}>{r.method}</span>
                                            <span style={{ fontSize: 11.5, color: 'rgba(222,199,255,0.45)', fontFamily: '"Fira Code",monospace' }}>{r.path}</span>
                                        </div>
                                    ))}
                                    <div className="lbl" style={labelBase}>
                                        <h5>Backend & APIs</h5>
                                        <p>Node.js · REST · GraphQL</p>
                                    </div>
                                </div>

                                {/* Card 4 — Performance */}
                                <div className="bc" style={{ ...cardBase, padding: '24px 24px 90px', display: 'flex', alignItems: 'flex-end', gap: 5 }}>
                                    {[32, 52, 40, 68, 48, 92, 65].map((h, i) => (
                                        <div key={i} style={{
                                            flex: 1,
                                            height: `${h}%`,
                                            borderRadius: '5px 5px 0 0',
                                            background: i === 5
                                                ? 'linear-gradient(to top, #5c27fe, #dec7ff)'
                                                : `rgba(92,39,254,${0.1 + i * 0.07})`,
                                        }} />
                                    ))}
                                    <div className="lbl" style={labelBase}>
                                        <div className="lbl-row">
                                            <div>
                                                <h5>Performance</h5>
                                                <p>Core Web Vitals · 100k+ rows</p>
                                            </div>
                                            <div className="grad-dot">
                                                <svg width="10" height="10" viewBox="0 0 12 12" fill="none"><path d="M2 10L10 2M10 2H4M10 2v6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            {/* Two-column bio section */}
                            <div className="bio-grid" style={{
                                display: 'grid',
                                gridTemplateColumns: '1fr 1fr',
                                gap: 40,
                                maxWidth: 900,
                                margin: '0 auto 40px',
                                textAlign: 'left',
                            }}>
                                {/* Left column */}
                                <div>
                                    <h6 style={{ color: '#dec7ff', fontSize: 12, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 14 }}>Who I Am</h6>
                                    <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: 15, lineHeight: 1.8, marginBottom: 16 }}>
                                        I'm Jacob Rajan — a Chennai-based Senior Full-Stack Engineer with 7+ years of experience crafting enterprise web applications. I've led development across security platforms, SaaS dashboards, and data-heavy interfaces at companies like DataSirpi and Wolphix.
                                    </p>
                                    <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 14, lineHeight: 1.8, marginBottom: 28 }}>
                                        I care deeply about clean architecture, developer experience, and shipping products that users actually enjoy — not just ones that technically work.
                                    </p>
                                    <Button title='More About Me' link='/about' />
                                </div>

                                {/* Right column */}
                                <div>
                                    <h6 style={{ color: '#dec7ff', fontSize: 12, fontWeight: 600, letterSpacing: 2, textTransform: 'uppercase', marginBottom: 14 }}>What I Bring</h6>
                                    <div className="bring-grid" style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
                                        {[
                                            {
                                                icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#dec7ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>,
                                                title: 'Speed without shortcuts', desc: 'I ship fast without cutting corners on code quality, testing, or scalability.'
                                            },
                                            {
                                                icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#dec7ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>,
                                                title: 'Product thinking', desc: 'I treat every feature as a product decision — not just a technical task to close.'
                                            },
                                            {
                                                icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#dec7ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><polyline points="8 21 12 17 16 21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>,
                                                title: 'Full ownership', desc: 'From system design to deployment, I own the entire development lifecycle.'
                                            },
                                            {
                                                icon: <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#dec7ff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M8 14s1.5 2 4 2 4-2 4-2"/><line x1="9" y1="9" x2="9.01" y2="9"/><line x1="15" y1="9" x2="15.01" y2="9"/></svg>,
                                                title: 'Design sensibility', desc: 'Strong eye for UI/UX — I bridge engineering and design in every project.'
                                            },
                                        ].map((item) => (
                                            <div key={item.title} className="bring-item" style={{ display: 'flex', gap: 14, alignItems: 'flex-start' }}>
                                                <div style={{
                                                    width: 36, height: 36, borderRadius: 10, flexShrink: 0,
                                                    background: 'linear-gradient(135deg, rgba(92,39,254,0.25) 0%, rgba(222,199,255,0.08) 100%)',
                                                    border: '1px solid rgba(222,199,255,0.12)',
                                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                                }}>
                                                    {item.icon}
                                                </div>
                                                <div>
                                                    <p style={{ color: '#fff', fontSize: 13, fontWeight: 600, margin: '0 0 3px' }}>{item.title}</p>
                                                    <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: 12.5, lineHeight: 1.6, margin: 0 }}>{item.desc}</p>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
}

export default About2;
